import { render } from "./HotkeyHint.vue?vue&type=template&id=0746baab"
const script = {}

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__